function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @ File:
 * @ Description:
 * @ Author: cqh
 * @ Create Time: 2023-02-15 18:01:35
 * @ Modified by: cqh
 * @ Modified time: 2023-09-01 17:53:48
 */
import React from 'react';
import { Tooltip } from 'antd';
// compose 接收函数进行批处理
export var compose = function compose(fns) {
  return function (value) {
    return fns.filter(Boolean).reduce(function (a, b) {
      return b(a);
    }, value);
  };
};

// 判断是否是函数
export var isFn = function isFn(i) {
  return typeof i === 'function';
};
// 排序函数
export var sortFn = function sortFn(v) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'order';
  return _toConsumableArray(v).sort(function (a, b) {
    return Number(a[key] || 0) - Number(b[key] || 0);
  });
};

// 使用search的  transForm 函数
export var toSearchTransForm = function toSearchTransForm(search, value) {
  var transForm = _typeof(search) === 'object' && search.transform;
  if (isFn(transForm)) {
    return transForm(value);
  }
  return value;
};

// 执行当前col定义的search 转换函数
export var usingColSearchTransForm = function usingColSearchTransForm(params) {
  var col = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  col.forEach(function (_ref) {
    var key = _ref.key,
      dataIndex = _ref.dataIndex,
      search = _ref.search;
    if (key && params[key]) {
      // 有key  定义key的情况下 就以key为主
      params[key] = toSearchTransForm(search, params[key]);
    } else if (!key && dataIndex && params[dataIndex]) {
      // 否则没有key  就去使用dataIndex
      params[dataIndex] = toSearchTransForm(search, params[dataIndex]);
    }
  });
};

// 对比两个对象的差异
export var diffChange = function diffChange(origin, target) {
  try {
    return JSON.stringify(origin) !== JSON.stringify(target);
  } catch (err) {
    return true;
  }
};

// 获取object的指定的key
export var getObjectKey = function getObjectKey(obj, keys) {
  var newMap = {};
  keys.forEach(function (key) {
    if (obj[key]) {
      newMap[key] = obj[key];
    }
  });
  return newMap;
};

/**
 *  转换obj的key
 * @param obj
 * @param oldKey
 * @param newKey
 * @returns
 */
export var transFromObjectKey = function transFromObjectKey(obj, oldKey, newKey) {
  if (oldKey in obj) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }
  return obj;
};

/**
 * 搜索是否展示
 * @param search
 * @returns
 */
export var isSearch = function isSearch(search) {
  return !!search.search || typeof search.renderFormItem === 'function';
};

/**
 *  断言是否所有参数都是true
 * @param rest
 * @returns
 */
export var EveryParamsByTrue = function EveryParamsByTrue() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }
  return rest.every(function (i) {
    return !!i;
  });
};

/**
 *  获取当前状态的类名
 * @param left
 * @param right
 * @returns
 */
export var getToolBarActive = function getToolBarActive(left, right) {
  return left === right ? 'super_table_size_list_item_active' : 'super_table_size_list_item';
};

/**
 *  取出search的 transform函数
 * @param search
 * @returns
 */
export var getSearchTransform = function getSearchTransform(search) {
  if (_typeof(search) === 'object') {
    if (typeof search.transform === 'function') {
      return search.transform;
    }
    return undefined;
  }
  return undefined;
};

/**
 *  toolBar 的默认参数
 * @param toolBar
 * @returns
 */
export var peelToolBarOption = function peelToolBarOption(toolBar) {
  if (!toolBar) {
    return false;
  }
  if (toolBar === true) {
    return {
      reload: true,
      changeSize: true,
      changeColumns: true
    };
  }
  if (!Array.isArray(toolBar.defaultActiveDataIndex)) {
    delete toolBar.defaultActiveDataIndex;
  }
  return toolBar;
};

/**
 *  处理render option
 * @param renderOptionBar
 * @returns
 */
export var getRenderOptionBar = function getRenderOptionBar(renderOptionBar) {
  if (!renderOptionBar) {
    return {};
  }
  if (typeof renderOptionBar === 'function') {
    return {
      center: renderOptionBar
    };
  }
  if (_typeof(renderOptionBar) === 'object') {
    return renderOptionBar;
  }
  return {};
};

/**
 *  --------------------------------------------------
 */

// 使用compose 进行的函数
/**
 *
 *  过滤search
 * @param {_usingExpandColParams} { data, expand, sliceCount, isShowExpand }
 * @return {*}
 */
var _SearchFormIsShow = function _SearchFormIsShow(_ref2) {
  var data = _ref2.data,
    expand = _ref2.expand,
    sliceCount = _ref2.sliceCount,
    isShowExpand = _ref2.isShowExpand;
  return {
    data: data === null || data === void 0 ? void 0 : data.filter(function (i) {
      return isSearch(i);
    }),
    expand: expand,
    sliceCount: sliceCount,
    isShowExpand: isShowExpand
  };
};

/**
 *  控制展开收起的函数
 * @param param0
 * @returns
 */
var _usingExpandCol = function _usingExpandCol(_ref3) {
  var data = _ref3.data,
    expand = _ref3.expand,
    sliceCount = _ref3.sliceCount,
    isShowExpand = _ref3.isShowExpand;
  if (expand) {
    if (isShowExpand) {
      return data === null || data === void 0 ? void 0 : data.slice(0, sliceCount);
    } else {
      return data;
    }
  } else {
    return data;
  }
};
/**
 *  判断是否需要退页码
 * @param param0
 * @returns
 */
var _backPageData = function _backPageData(_ref4) {
  var length = _ref4.length,
    pageNo = _ref4.pageNo,
    flag = _ref4.flag;
  return !!(!length && pageNo > 1 && flag);
};
/**
 *  移除 hide的col  供 table使用
 * @param columns
 * @returns
 */
var _moveHide = function _moveHide(columns) {
  return columns.filter(function (i) {
    return !i.hide;
  });
};

/**
 * 切割文字并且填充省略号
 */
var _sliceTextEllipsis = function _sliceTextEllipsis(_ref5) {
  var text = _ref5.text,
    len = _ref5.len;
  var isOver = false;
  var originText = text;
  if (text.length > len) {
    isOver = true;
    text = text.slice(0, len - 1) + '...';
  }
  return {
    text: text,
    isOver: isOver,
    originText: originText
  };
};

/**
 *  填充tooltip参数
 * @param col
 * @returns
 */
var _filltooltip = function _filltooltip(col) {
  return col.map(function (i) {
    if (!('labelTooltip' in i)) {
      i.labelTooltip = true;
    }
    return i;
  });
};

/**
 *  使用toolTip
 * @param formItem
 * @returns
 */
var _usingToolTip = function _usingToolTip(formItem) {
  var sliceLen = formItem.tooltipSliceLen || 6;
  if (!formItem.labelTooltip) return formItem;
  var sliceResultObject = _sliceTextEllipsis({
    text: formItem === null || formItem === void 0 ? void 0 : formItem.label,
    len: sliceLen
  });
  if (sliceResultObject.isOver) {
    formItem.label = /*#__PURE__*/React.createElement(Tooltip, {
      title: sliceResultObject.originText,
      placement: "top"
    }, sliceResultObject.text);
  }
  return formItem;
};
var usingExpandCol = compose([_SearchFormIsShow, _usingExpandCol]);
var backPageData = compose([_backPageData]);
var moveHide = compose([_moveHide]);
var sliceTextEllipsis = compose([_sliceTextEllipsis]);
var filltooltip = compose([_filltooltip]);
var usingToolTip = compose([_usingToolTip]);
var composeColum = compose([sortFn, _filltooltip]);
export { usingExpandCol, backPageData, moveHide, sliceTextEllipsis, filltooltip, usingToolTip, composeColum };